webpackJsonp([2],{

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(346);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  var videos = (0, _jquery2.default)('.js-video-init');

  if (!videos.length) {
    return;
  }

  __webpack_require__.e/* require.ensure */(9).then((function (require) {
    __webpack_require__(371);
    __webpack_require__(372);

    videos.each(function (i, item) {
      var $video = (0, _jquery2.default)(item);
      var video = videojs($video[0]);

      video.on('play', function (event) {
        (0, _jquery2.default)(event.target).parents('.js-video-wrapper').find('.js-video-title').hide();
      });
    });
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}); /* eslint-disable no-unused-vars, no-console */

/***/ })

});


// WEBPACK FOOTER //
// videojs-c78ad3d08dc82d1a4cc7.js